import StatInsightEditing from './stat-insight-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class StatInsightUI extends Plugin {
    init() { }
}
export default class StatInsight extends Plugin {
    static get requires() {
        return [StatInsightEditing, StatInsightUI];
    }
}
